"use strict";

/**
 * @module Features.Security
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SessionPropertyValidationImpl = void 0;
/**
 * Implementation of {@link SessionPropertyValidation}
 *
 * @inheritdoc
 */
var SessionPropertyValidationImpl = /** @class */function () {
  /**
   * Create a SessionPropertyValidationImpl instance
   *
   * @param  type   the type of validation
   */
  function SessionPropertyValidationImpl(type) {
    this.type = type;
  }
  return SessionPropertyValidationImpl;
}();
exports.SessionPropertyValidationImpl = SessionPropertyValidationImpl;